<template>
  <v-app>
    <AppHeader />
    <v-main>
      <br />
      <br />
      <br />
      <div
        id="boardsContainer"
        style="display:flex; margin-left: 20px; flex-direction:row; width:100%; flex-wrap: wrap; max-width:900px; margin: auto;"
      >
        <v-card style="margin:10px" width="250" height="300">
          <v-card-text
            style="height:100%; display:flex; flex-direction:column; justify-content: space-around; align-items: center;"
          >
            <div style="font-size:200px">+</div>
            <div>
              <v-text-field
                v-model="newBoardTitle"
                label="add board and press enter"
                v-on:keydown="keydownNewBoard"
                required
              ></v-text-field>
            </div>
          </v-card-text>
        </v-card>
        <BoardCard
          v-for="board in boards"
          :key="board.id"
          :board="board"
          :boards="boards"
          @boardsChanged="init"
          :boardDragging="boardDragging"
          @startBoardDragging="startBoardDragging"
          @endBoardDragging="endBoardDragging"
        ></BoardCard>
      </div>
    </v-main>
  </v-app>
</template>

<script>
import AppHeader from "./AppHeader";
import BoardCard from "./BoardCard";
import * as api from "./api";

export default {
  name: "Home",
  components: {
    AppHeader,
    BoardCard,
  },
  props: {
    boards: Array,
  },
  async mounted() {
    this.init();
  },
  data: () => ({
    boards: [],
    draggedEl: null,
    newBoardTitle: "",
    boardDragging: null,
  }),
  computed: {},
  methods: {
    startBoardDragging(board) {
      this.boardDragging = board;
    },
    endBoardDragging() {
      this.boardDragging = null;
    },
    async init() {
      this.boards = await api.getBoards();
      this.boards
        .sort((a, b) => a.ordinal - b.ordinal)
        .forEach((b) => (b.orig = { ...b }));
    },
    async leaveBoard(b) {
      if (confirm(`are you sure you want to leave ${b.title}?`)) {
        await api.leaveBoard(b);
        this.init();
      }
    },
    async deleteBoard(b) {
      if (confirm(`are you sure you want to delete ${b.title}?`)) {
        await api.deleteBoard(b);
        this.init();
      }
    },
    async keydownBoard(e, board) {
      if (e.key === "Enter") {
        // debugger; // eslint-disable-line
        e.preventDefault();
        await api.updateBoard(board);
        await this.init();
      }
    },

    async keydownNewBoard(e) {
      if (e.key === "Enter") {
        e.preventDefault();
        await api.createBoard(this.newBoardTitle);
        this.newBoardTitle = "";
        await this.init();
        // this.boardChange(this.boards.length - 1);
      }
    },
  },
};
</script>

<style scoped>
.left {
  position: relative;
  left: 50px;
}
</style>